const ERROR_TEXT = 'Something went wrong. Please try again later.';

export default ERROR_TEXT;
